import { render, staticRenderFns } from "./cFooter.vue?vue&type=template&id=bf653d0e&scoped=true&"
import script from "./cFooter.vue?vue&type=script&lang=js&"
export * from "./cFooter.vue?vue&type=script&lang=js&"
import style0 from "./cFooter.vue?vue&type=style&index=0&id=bf653d0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf653d0e",
  null
  
)

export default component.exports